export const isInViewport = (ref) => {
  if (!ref || !ref.current || !ref.current.id) return false
  const rect = ref.current.getBoundingClientRect() || {}
  return (
    rect.top > 100 &&
    rect.top <=
      (window.innerHeight / 2 || document.documentElement.clientHeight / 2)
  )
}
